import React from 'react';
import {Link} from 'react-router-dom';
import * as util from '../../../utils';
const flameImg = require('../../../images/flame.png')

class HotPackage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hotData: [],
            hotPackage: 'all'
        };
    }

    componentDidMount() {
       this.getDetail()
    }
    async getDetail() {
        const hotData: any = await util.get('/package/hotPackage', {hotPackageType: this.state.hotPackage});
        this.setState({hotData: hotData.data});
    }

    changeHotType(str) {
        this.setState({hotPackage: str}, () => {
            this.getDetail()
        });
    }

    render() {
        const {hotData = []} = this.state;
        console.log(hotData)
        return (
            <div className='hot-packages-container'>
                <p className='title'>热搜榜单</p>
                {/*<div className='hot-search-title'>*/}
                {/*    <span className={this.state.hotPackage === 'all' ? 'active' : ''} onClick={() =>this.changeHotType('all')}>总榜</span>*/}
                {/*    <span className={this.state.hotPackage === 'mdf' ? 'active' : ''} onClick={() =>this.changeHotType('mdf')}>MDF热门组件</span>*/}
                {/*</div>*/}
                {
                    hotData.map((item, index) =>
                        <div>
                            <Link to={'/package/detail/' + item.name} className="package-item" key={item.name}>
                                <span className={`rank rank${index + 1}`}>{index + 1}</span>
                                <span className='package-name'>{item.name}</span>
                                <span className='package-download'>
                                    {item.download || 0}
                                    <img src={flameImg} />
                                </span>
                            </Link>
                        </div>
                    )
                }
            </div>
        );
    }
}

export default HotPackage;
